import React from "react";
import FuelingByCityChart from "./FuelingByCityChart";
import { getNetworkCountry } from "../lib/networkDisplay";

/**
 * Phase 3E-9M · Mixed Canada/USA analytics wrapper.
 *
 * When the operator's current network/country filter combination yields
 * MIXED-country data (either explicitly "both networks" or a
 * multi-country customer), render TWO independent geographic panels:
 *
 *   Canada — Province Breakdown  →  city drilldown (L, CAD)
 *   USA — State Breakdown        →  city drilldown (GAL, USD)
 *
 * When only one country applies, only that panel is rendered so the UI
 * doesn't show an empty second chart.
 *
 * §15: NEVER sums L + GAL together. Each panel is its own aggregation.
 * §17: Drilldown state lives per-panel (each FuelingByCityChart manages
 *      its own selected jurisdiction), so a filter change that removes
 *      one country automatically unmounts that panel and its stale
 *      drilldown selection.
 */
export default function MixedCountryCharts({
  customerId,
  network,   // optional filter
  country,   // optional filter — when unset, both panels can render
  defaultDays = 90,
}) {
  const inferred = getNetworkCountry(network, country);
  // Show BOTH panels when: no country locked AND (no network OR network is a
  // country-ambiguous key). Otherwise render only the applicable panel.
  const showBoth = !country && (!network || (
    inferred === "" && network !== "ta_petro" && network !== "petro_pass_us"
                    && network !== "esso"    && network !== "pipeline"
                    && network !== "petro_pass_ca"
  ));

  if (!showBoth) {
    return (
      <FuelingByCityChart
        customerId={customerId}
        defaultDays={defaultDays}
        network={network}
        country={country || inferred}
        data-testid="fueling-single-country"
      />
    );
  }

  return (
    <div className="space-y-4" data-testid="fueling-mixed-country-wrap">
      <FuelingByCityChart
        customerId={customerId}
        defaultDays={defaultDays}
        network={network || undefined}
        country="CA"
      />
      <FuelingByCityChart
        customerId={customerId}
        defaultDays={defaultDays}
        network={network || undefined}
        country="US"
      />
    </div>
  );
}
